var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"src":_vm.animationUrl,"controls":"","playsInline":"","controlsList":"nodownload"}})}
var staticRenderFns = []

export { render, staticRenderFns }